require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.map");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./clojure.string.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("expound.ansi.js");
goog.provide('expound.ansi');
/**
 * Map of symbols to numeric SGR (select graphic rendition) codes.
 */

expound.ansi.sgr_code = cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "bold", "bold", -116809535), new cljs.core.Keyword(null, "blink", "blink", -271985917), new cljs.core.Keyword(null, "white", "white", -483998618), new cljs.core.Keyword(null, "yellow", "yellow", -881035449), new cljs.core.Keyword(null, "bg-red", "bg-red", -1645498040), new cljs.core.Keyword(null, "bg-cyan", "bg-cyan", -1582237015), new cljs.core.Keyword(null, "green", "green", -945526839), new cljs.core.Keyword(null, "bg-green", "bg-green", -138353590), new cljs.core.Keyword(null, "fg-reset", "fg-reset", 1908873578), new cljs.core.Keyword(null, "cyan", "cyan", 1118839274), new cljs.core.Keyword(null, "bg-black", "bg-black", 2110303851), new cljs.core.Keyword(null, "fg-256", "fg-256", -255017013), new cljs.core.Keyword(null, "underline", "underline", 2018066703), new cljs.core.Keyword(null, "bg-magenta", "bg-magenta", 2073641232), new cljs.core.Keyword(null, "strike", "strike", -1173815471), new cljs.core.Keyword(null, "bg-yellow", "bg-yellow", -1293468429), new cljs.core.Keyword(null, "hidden", "hidden", -312506092), new cljs.core.Keyword(null, "red", "red", -969428204), new cljs.core.Keyword(null, "blue", "blue", -622100620), new cljs.core.Keyword(null, "bg-white", "bg-white", -1453241673), new cljs.core.Keyword(null, "bg-256", "bg-256", 1097886744), new cljs.core.Keyword(null, "magenta", "magenta", 1687937081), new cljs.core.Keyword(null, "bg-blue", "bg-blue", -1747478308), new cljs.core.Keyword(null, "bg-reset", "bg-reset", 857739453), new cljs.core.Keyword(null, "none", "none", 1333468478), new cljs.core.Keyword(null, "reverse", "reverse", -888455266), new cljs.core.Keyword(null, "black", "black", 1294279647)], [1, 5, 37, 33, 41, 46, 32, 42, 39, 36, 40, 38, 3, 45, 9, 43, 8, 31, 34, 47, 48, 35, 44, 49, 0, 7, 30]);
expound.ansi._STAR_enable_color_STAR_ = false;
/**
 * Returns an ANSI escope string which will apply the given collection of SGR
 *   codes.
 */

expound.ansi.esc = function expound$ansi$esc(codes) {
  var codes__$1 = cljs.core.map.cljs$core$IFn$_invoke$arity$3(expound.ansi.sgr_code, codes, codes);
  var codes__$2 = clojure.string.join.cljs$core$IFn$_invoke$arity$2(";", codes__$1);
  return ["\x1B", "[", codes__$2, "m"].join('');
};
/**
 * Returns an ANSI escope string which will enact the given SGR codes.
 */


expound.ansi.escape = function expound$ansi$escape(var_args) {
  var args__4742__auto__ = [];
  var len__4736__auto___30701 = arguments.length;
  var i__4737__auto___30702 = 0;

  while (true) {
    if (i__4737__auto___30702 < len__4736__auto___30701) {
      args__4742__auto__.push(arguments[i__4737__auto___30702]);
      var G__30703 = i__4737__auto___30702 + 1;
      i__4737__auto___30702 = G__30703;
      continue;
    } else {}

    break;
  }

  var argseq__4743__auto__ = 0 < args__4742__auto__.length ? new cljs.core.IndexedSeq(args__4742__auto__.slice(0), 0, null) : null;
  return expound.ansi.escape.cljs$core$IFn$_invoke$arity$variadic(argseq__4743__auto__);
};

expound.ansi.escape.cljs$core$IFn$_invoke$arity$variadic = function (codes) {
  return expound.ansi.esc(codes);
};

expound.ansi.escape.cljs$lang$maxFixedArity = 0;
/** @this {Function} */

expound.ansi.escape.cljs$lang$applyTo = function (seq30694) {
  var self__4724__auto__ = this;
  return self__4724__auto__.cljs$core$IFn$_invoke$arity$variadic(cljs.core.seq(seq30694));
};
/**
 * Wraps the given string with SGR escapes to apply the given codes, then reset
 *   the graphics.
 */


expound.ansi.sgr = function expound$ansi$sgr(var_args) {
  var args__4742__auto__ = [];
  var len__4736__auto___30704 = arguments.length;
  var i__4737__auto___30705 = 0;

  while (true) {
    if (i__4737__auto___30705 < len__4736__auto___30704) {
      args__4742__auto__.push(arguments[i__4737__auto___30705]);
      var G__30706 = i__4737__auto___30705 + 1;
      i__4737__auto___30705 = G__30706;
      continue;
    } else {}

    break;
  }

  var argseq__4743__auto__ = 1 < args__4742__auto__.length ? new cljs.core.IndexedSeq(args__4742__auto__.slice(1), 0, null) : null;
  return expound.ansi.sgr.cljs$core$IFn$_invoke$arity$variadic(arguments[0], argseq__4743__auto__);
};

expound.ansi.sgr.cljs$core$IFn$_invoke$arity$variadic = function (string, codes) {
  return [expound.ansi.esc(codes), cljs.core.str.cljs$core$IFn$_invoke$arity$1(string), expound.ansi.escape.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "none", "none", 1333468478)], 0))].join('');
};

expound.ansi.sgr.cljs$lang$maxFixedArity = 1;
/** @this {Function} */

expound.ansi.sgr.cljs$lang$applyTo = function (seq30696) {
  var G__30697 = cljs.core.first(seq30696);
  var seq30696__$1 = cljs.core.next(seq30696);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__30697, seq30696__$1);
};

expound.ansi._STAR_print_styles_STAR_ = cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "good-key", "good-key", -1265033983), new cljs.core.Keyword(null, "warning-key", "warning-key", -1487066651), new cljs.core.Keyword(null, "correct-key", "correct-key", 1087492967), new cljs.core.Keyword(null, "highlight", "highlight", -800930873), new cljs.core.Keyword(null, "focus-path", "focus-path", -2048689431), new cljs.core.Keyword(null, "bad-value", "bad-value", -139100659), new cljs.core.Keyword(null, "footer", "footer", 1606445390), new cljs.core.Keyword(null, "header", "header", 119441134), new cljs.core.Keyword(null, "good-pred", "good-pred", -629085297), new cljs.core.Keyword(null, "good", "good", 511701169), new cljs.core.Keyword(null, "focus-key", "focus-key", 2074966449), new cljs.core.Keyword(null, "pointer", "pointer", 85071187), new cljs.core.Keyword(null, "bad", "bad", 1127186645), new cljs.core.Keyword(null, "error-key", "error-key", -1651308715), new cljs.core.Keyword(null, "none", "none", 1333468478), new cljs.core.Keyword(null, "message", "message", -406056002)], [new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "green", "green", -945526839)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "bold", "bold", -116809535)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "green", "green", -945526839)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "bold", "bold", -116809535)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "magenta", "magenta", 1687937081)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "red", "red", -969428204)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "cyan", "cyan", 1118839274)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "cyan", "cyan", 1118839274)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "green", "green", -945526839)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "green", "green", -945526839)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "bold", "bold", -116809535)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "magenta", "magenta", 1687937081)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "red", "red", -969428204)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "red", "red", -969428204)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "none", "none", 1333468478)], null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "magenta", "magenta", 1687937081)], null)]);

expound.ansi.resolve_styles = function expound$ansi$resolve_styles(styles) {
  var temp__5802__auto__ = cljs.core.not_empty(cljs.core.mapcat.cljs$core$IFn$_invoke$arity$variadic(function (p1__30698_SHARP_) {
    var or__4126__auto__ = function () {
      var temp__5804__auto__ = expound.ansi._STAR_print_styles_STAR_.call(null, p1__30698_SHARP_);

      if (cljs.core.truth_(temp__5804__auto__)) {
        var res = temp__5804__auto__;
        return res;
      } else {
        return null;
      }
    }();

    if (cljs.core.truth_(or__4126__auto__)) {
      return or__4126__auto__;
    } else {
      return new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [p1__30698_SHARP_], null);
    }
  }, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([styles], 0)));

  if (cljs.core.truth_(temp__5802__auto__)) {
    var res = temp__5802__auto__;
    return res;
  } else {
    return new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "bold", "bold", -116809535)], null);
  }
};

expound.ansi.color = function expound$ansi$color(var_args) {
  var args__4742__auto__ = [];
  var len__4736__auto___30707 = arguments.length;
  var i__4737__auto___30708 = 0;

  while (true) {
    if (i__4737__auto___30708 < len__4736__auto___30707) {
      args__4742__auto__.push(arguments[i__4737__auto___30708]);
      var G__30709 = i__4737__auto___30708 + 1;
      i__4737__auto___30708 = G__30709;
      continue;
    } else {}

    break;
  }

  var argseq__4743__auto__ = 1 < args__4742__auto__.length ? new cljs.core.IndexedSeq(args__4742__auto__.slice(1), 0, null) : null;
  return expound.ansi.color.cljs$core$IFn$_invoke$arity$variadic(arguments[0], argseq__4743__auto__);
};

expound.ansi.color.cljs$core$IFn$_invoke$arity$variadic = function (s, styles) {
  if (cljs.core.truth_(expound.ansi._STAR_enable_color_STAR_)) {
    return cljs.core.apply.cljs$core$IFn$_invoke$arity$3(expound.ansi.sgr, s, expound.ansi.resolve_styles(styles));
  } else {
    return s;
  }
};

expound.ansi.color.cljs$lang$maxFixedArity = 1;
/** @this {Function} */

expound.ansi.color.cljs$lang$applyTo = function (seq30699) {
  var G__30700 = cljs.core.first(seq30699);
  var seq30699__$1 = cljs.core.next(seq30699);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__30700, seq30699__$1);
};

Object.defineProperty(module.exports, "sgr_code", {
  enumerable: false,
  get: function get() {
    return expound.ansi.sgr_code;
  }
});
Object.defineProperty(module.exports, "_STAR_enable_color_STAR_", {
  enumerable: false,
  get: function get() {
    return expound.ansi._STAR_enable_color_STAR_;
  }
});
Object.defineProperty(module.exports, "esc", {
  enumerable: false,
  get: function get() {
    return expound.ansi.esc;
  }
});
Object.defineProperty(module.exports, "escape", {
  enumerable: false,
  get: function get() {
    return expound.ansi.escape;
  }
});
Object.defineProperty(module.exports, "sgr", {
  enumerable: false,
  get: function get() {
    return expound.ansi.sgr;
  }
});
Object.defineProperty(module.exports, "_STAR_print_styles_STAR_", {
  enumerable: false,
  get: function get() {
    return expound.ansi._STAR_print_styles_STAR_;
  }
});
Object.defineProperty(module.exports, "resolve_styles", {
  enumerable: false,
  get: function get() {
    return expound.ansi.resolve_styles;
  }
});
Object.defineProperty(module.exports, "color", {
  enumerable: false,
  get: function get() {
    return expound.ansi.color;
  }
});